(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405,8389],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(9844);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C2": function() { return /* binding */ BannerBox; },
/* harmony export */   "UP": function() { return /* binding */ BannerContainer; },
/* harmony export */   "cW": function() { return /* binding */ BannerImage; },
/* harmony export */   "gY": function() { return /* binding */ BannerSlider; }
/* harmony export */ });
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4337);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9447);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100vw;\n  padding: 2.125rem 1rem;\n  margin-top: -1rem;\n  background-color: blue-100;\n\n  @media (min-width: desktop) {\n    padding: 1.75rem 2rem 1.375rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 5rem;\n  width: 88%;\n  padding: 1.75rem 1.5rem 2rem;\n  border-radius: 24px;\n  background-color: white;\n  z-index: 1;\n\n  @media (min-width: desktop) {\n    max-width: 420px;\n    padding: 3rem 3.25rem;\n    top: 5rem;\n\n    p {\n      margin: 1rem 0 0;\n    }\n  }\n\n  @media (max-width: desktop) {\n    position: static;\n    transform: translateY(-20%);\n\n    p {\n      margin: 2rem 0 0;\n    }\n  }\n\n  @media (min-width: tablet) and (max-width: desktop) {\n    max-width: 420px;\n    height: auto;\n    padding: 2rem;\n    top: 5rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  /* height: min(50vw, 465px); */\n\n  @media (min-width: desktop) {\n    left: 15rem;\n  }\n\n  @media (min-width: desktop) and (max-width: 1064.98px) {\n    width: 720px;\n  }\n\n  @media (min-width: 1065px) {\n    width: 750px;\n  }\n\n  @media (min-width: lg_desktop) {\n    width: 890px;\n  }\n\n  img {\n    border-radius: 12px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  @media (min-width: desktop) {\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n  }\n\n  @media (max-width: desktop) {\n    position: initial;\n  }\n\n  .swiper-pagination-bullets {\n    bottom: 2rem;\n\n    @media (max-width: desktop) {\n      bottom: 1rem;\n    }\n  }\n\n  .swiper-pagination-bullet {\n    transform: scale(1.3);\n    margin: 0 10px !important;\n  }\n\n  .swiper-pagination-bullet-active {\n    background-color: teal-300;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var BannerContainer = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].sectionBox */ .ZPm.sectionBox(_templateObject());
var BannerBox = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].divBox */ .ZPm.divBox(_templateObject1());
var BannerImage = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].divBox */ .ZPm.divBox(_templateObject2());
var BannerSlider = (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZPm)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .Swiper */ .t)(_templateObject3());


/***/ }),

/***/ 7184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CarouselArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4337);


function CarouselArrow(param) {
    var onClick = param.onClick, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
        as: "span",
        role: "button",
        "aria-label": "Arrow for toggling between slides",
        onClick: onClick,
        children: children
    });
};


/***/ }),

/***/ 681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProductCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var hooks_products_useProductCardPrice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9926);
/* harmony import */ var utils_getProductImage__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7883);
/* harmony import */ var _DiscountPercentBadge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4522);
/* harmony import */ var _UI_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9696);
/* harmony import */ var _UI_Primitives_ClientOnly__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1028);
/* harmony import */ var _UI_Button_AddToCart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5618);
/* harmony import */ var _UI_Ratings_StarRating__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9565);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4567);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}










/**
 * ProductCard
 *
 * Generic product card component
 *
 * @prop {object} product - object of a single product
 * @prop {object} imageSize - object of image width and height {width, height}
 * @prop {object} badges - object of badges to show/hide with custom content
 * @prop {boolean} hideRating - to toggle if rating is hidden
 * @prop {float} scale - image transform scale
 * @prop {float} hoverScale - image transform scale on hover
 */ function ProductCard(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var price = (0,hooks_products_useProductCardPrice__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((ref = props.product) === null || ref === void 0 ? void 0 : ref.price_range);
    var image = (0,utils_getProductImage__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        mainImage: props.product.image,
        gallery: props.product.media_gallery
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_8__/* .ProductCardBox */ .Ps, _objectSpread({}, props, {
        hoverScale: props.hoverScale,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/toode/[toode]",
                as: "/toode/".concat(props.product.url_key),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    children: [
                        !props.hideRating && ((ref1 = props.product) === null || ref1 === void 0 ? void 0 : ref1.rating_summary) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Ratings_StarRating__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            rating: (ref2 = props.product) === null || ref2 === void 0 ? void 0 : ref2.rating_summary,
                            flexDirection: "column",
                            position: "absolute",
                            right: props.scale ? "0.35rem" : "0.6rem",
                            top: props.scale ? "0.25rem" : "0.5rem"
                        }) : null,
                        (price === null || price === void 0 ? void 0 : (ref3 = price.discount) === null || ref3 === void 0 ? void 0 : ref3.value) && ((ref4 = props.badges) === null || ref4 === void 0 ? void 0 : ref4.discount) || ((ref5 = props.badges) === null || ref5 === void 0 ? void 0 : ref5.discount.text) === "Lemmik" || ((ref6 = props.badges) === null || ref6 === void 0 ? void 0 : ref6.discount.text) === "Favourite" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            id: "discount_badge",
                            children: props.badges.discount.text || "Soodus"
                        }) : null,
                        (price === null || price === void 0 ? void 0 : (ref7 = price.discount) === null || ref7 === void 0 ? void 0 : ref7.percentNumber) > 0 && !((ref8 = props.badges) === null || ref8 === void 0 ? void 0 : ref8.discount) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DiscountPercentBadge__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            percent: "-" + Math.round(Number(price === null || price === void 0 ? void 0 : (ref9 = price.discount) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.percent) === null || ref10 === void 0 ? void 0 : ref10.replace("-", "").replace(" ", "").replace("kuni", "").replace("%", ""))) + "%"
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            src: image === null || image === void 0 ? void 0 : image.url,
                            alt: image === null || image === void 0 ? void 0 : image.label,
                            width: props.imageSize.width,
                            height: props.imageSize.height,
                            objectFit: "contain"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_8__/* .ProductTitle */ .tc, {
                            scale: props.scale,
                            children: (ref11 = props.product) === null || ref11 === void 0 ? void 0 : ref11.name
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_8__/* .ProductPrice */ .jF, {
                            scale: props.scale,
                            children: [
                                (price === null || price === void 0 ? void 0 : (ref12 = price.discount) === null || ref12 === void 0 ? void 0 : ref12.value) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: price === null || price === void 0 ? void 0 : (ref13 = price.discount) === null || ref13 === void 0 ? void 0 : ref13.value
                                }) : null,
                                price === null || price === void 0 ? void 0 : price.value
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_8__/* .ButtonsContainer */ .YD, {
                spaceX: "1rem",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Primitives_ClientOnly__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Button_AddToCart__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        product: props.product
                    })
                })
            })
        ]
    }));
};


/***/ }),

/***/ 7810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Skeleton_module_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8609);
/* harmony import */ var _Skeleton_module_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Skeleton_module_css__WEBPACK_IMPORTED_MODULE_1__);


var SkeletonElement = function(param) {
    var type = param.type;
    // const classes = `skeleton ${type}`;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Skeleton_module_css__WEBPACK_IMPORTED_MODULE_1___default())[type]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonElement);


/***/ }),

/***/ 3327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _SkeletonElement__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7810);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4337);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  max-width: 270px;\n  padding: 0 1.25rem;\n  margin-right: 0.5rem;\n  border: 0.7px solid #d8d9e5;\n  border-radius: 12px;\n  background-color: white;\n  font-weight: 500;\n  height: 369.88px;\n  padding: '1rem 1rem 2rem';\n\n  @media (max-width: lg_tablet) {\n    border: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex-direction: column;\n  padding-bottom: 15%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var SkeletonProductCard = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SkeletonProductBox, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                type: "skeletonproductimage"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SkeletonInfo, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "skeletontitle"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "skeletontext"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        type: "skeletontext"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonProductCard);
var SkeletonProductBox = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].divBox */ .ZPm.divBox(_templateObject());
var SkeletonInfo = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZPm.div(_templateObject1());


/***/ }),

/***/ 9081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _SkeletonElement__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7810);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4337);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  height: 100%;\n  width: 200px;\n  height: 250px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  padding: 2.5rem 1.25rem 1rem;\n  margin-right: 0.5rem;\n  /* border: 0.7px solid #d8d9e5; */\n  border-radius: 12px;\n  background-color: white;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var SkeletonSmallCard = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SkeletonProductBox, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                type: "skeletonproductimage"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                type: "skeletontitle"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                type: "skeletontext"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SkeletonElement__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                type: "skeletontext"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonSmallCard);
var SkeletonProductBox = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].divBox */ .ZPm.divBox(_templateObject());


/***/ }),

/***/ 4457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCatalogue; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3359);
/* harmony import */ var jotai_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1131);
/* harmony import */ var global_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(561);
/* harmony import */ var graphql_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4462);
/* harmony import */ var utils_getCategoryId__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4244);
/* harmony import */ var _useProductPages__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8812);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








function useCatalogue() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var lang = router.locale ? router.locale : "et";
    // Get category url slug
    var categorySlug = router.asPath.split("/").pop().split("?")[0];
    // Get category ID
    var id = (0,utils_getCategoryId__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(categorySlug);
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), productCount = ref6[0], setProductCount = ref6[1];
    var pageSize = (0,jotai_utils__WEBPACK_IMPORTED_MODULE_6__/* .useAtomValue */ .Dv)(global_store__WEBPACK_IMPORTED_MODULE_2__/* .pageSizeAtom */ .Gx);
    var currentPage = (0,jotai_utils__WEBPACK_IMPORTED_MODULE_6__/* .useAtomValue */ .Dv)(global_store__WEBPACK_IMPORTED_MODULE_2__/* .currentPageAtom */ .ef);
    var ref1 = (0,jotai_utils__WEBPACK_IMPORTED_MODULE_6__/* .useAtomValue */ .Dv)(global_store__WEBPACK_IMPORTED_MODULE_2__/* .sortAtom */ .xe), sortBy = ref1.value;
    var ref2 = (0,jotai_utils__WEBPACK_IMPORTED_MODULE_6__/* .useAtomValue */ .Dv)(global_store__WEBPACK_IMPORTED_MODULE_2__/* .filtersAtom */ .ot), price = ref2.price, brand = ref2.brand, v__rv = ref2.v__rv;
    // Prepare query variables
    var queryVariables = {
        id: id,
        price: price,
        brand: brand,
        v__rv: v__rv,
        sortBy: sortBy,
        currentPage: currentPage,
        pageSize: pageSize
    };
    // Get category products
    var ref3 = _slicedToArray((0,_apollo_client__WEBPACK_IMPORTED_MODULE_7__/* .useLazyQuery */ .t)(graphql_queries__WEBPACK_IMPORTED_MODULE_3__/* .CATEGORY_PRODUCTS */ .h$, {
        variables: queryVariables,
        context: {
            headers: {
                store: lang
            },
            fetchOptions: {
                method: "GET"
            }
        },
        fetchPolicy: "network-only",
        errorPolicy: "all",
        onCompleted: function(data) {
            var ref;
            var count = data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : ref.total_count;
            if (count && productCount !== count) {
                setProductCount(count);
            }
        }
    }), 2), getProducts = ref3[0], ref4 = ref3[1], data1 = ref4.data, loading = ref4.loading, error = ref4.error, called = ref4.called;
    var ref5 = (0,_useProductPages__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(getProducts, data1), products = ref5.products, pages = ref5.pages;
    return {
        products: products,
        loading: loading,
        pages: pages,
        count: productCount
    };
};


/***/ }),

/***/ 8812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useProductPages; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1131);
/* harmony import */ var global_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(561);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




function useProductPages(getProducts, data) {
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), products = ref4[0], setProducts = ref4[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), pages = ref1[0], setPages = ref1[1];
    var ref2 = _slicedToArray((0,jotai__WEBPACK_IMPORTED_MODULE_2__/* .useAtom */ .KO)(global_store__WEBPACK_IMPORTED_MODULE_1__/* .currentPageAtom */ .ef), 2), currentPage = ref2[0], setCurrentPage = ref2[1];
    // Execute products query upon page change
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return getProducts();
    }, [
        currentPage
    ]);
    // Set products & pages
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (data === null || data === void 0 ? void 0 : data.products) {
            var ref, ref3;
            setProducts(data === null || data === void 0 ? void 0 : data.products.items);
            var pageAmount = data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : (ref3 = ref.page_info) === null || ref3 === void 0 ? void 0 : ref3.total_pages;
            if (pages !== pageAmount) {
                setPages(pageAmount);
            }
        }
    }, [
        data === null || data === void 0 ? void 0 : data.products
    ]);
    return {
        products: products,
        pages: pages
    };
};


/***/ }),

/***/ 9844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./graphql/apollo-client.js + 11 modules
var apollo_client = __webpack_require__(5865);
// EXTERNAL MODULE: ./components/UI/Layout/index.js
var Layout = __webpack_require__(3793);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(4002);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(172);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/autoplay/autoplay.js
var autoplay = __webpack_require__(7649);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/pagination/pagination.js
var pagination = __webpack_require__(2997);
// EXTERNAL MODULE: ./node_modules/@xstyled/styled-components/dist/styled-components.esm.js
var styled_components_esm = __webpack_require__(4337);
// EXTERNAL MODULE: ./components/UI/Primitives/FlexBox.js
var FlexBox = __webpack_require__(5653);
;// CONCATENATED MODULE: ./components/UI/Icons/Banner/index.js

// Inventory icon for homepage banner headline
var Inventory = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
        id: "Group_391",
        "data-name": "Group 391",
        transform: "translate(-46.709 -19.709)",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                id: "Rectangle_299",
                "data-name": "Rectangle 299",
                width: "32",
                height: "32",
                rx: "2",
                transform: "translate(46.709 19.709)",
                fill: "#a8e5e6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Path_246",
                "data-name": "Path 246",
                d: "M65.684,20V35.854l-6.342-6.342L53,35.854V20Z",
                transform: "translate(3.513 -0.291)",
                fill: "#ff7058"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Path_247",
                "data-name": "Path 247",
                d: "M57.22,35.085H49.293a.793.793,0,0,1,0-1.585H57.22a.793.793,0,0,1,0,1.585Z",
                transform: "translate(0.878 7.903)",
                fill: "#334a5e"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Path_248",
                "data-name": "Path 248",
                d: "M61.976,38.085H49.293a.793.793,0,0,1,0-1.585H61.976a.793.793,0,1,1,0,1.585Z",
                transform: "translate(0.878 9.66)",
                fill: "#334a5e"
            })
        ]
    })
});
// Transportation icon for homepage banner headline
var Transport = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "45.703",
    height: "33.457",
    viewBox: "0 0 45.703 33.457",
    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
        id: "delivery-truck",
        transform: "translate(0 -68.597)",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Path_211",
                "data-name": "Path 211",
                d: "M340.146,164.8h-9.437v17.1H346.17v-7.7l-1.8-6.232a4.395,4.395,0,0,0-4.221-3.173",
                transform: "translate(-301.192 -87.616)",
                fill: "#ff7058"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Path_212",
                "data-name": "Path 212",
                d: "M365.829,196.043l-1.607-5.555a2.261,2.261,0,0,0-2.16-1.623h-7.289v7.179Z",
                transform: "translate(-323.108 -109.533)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Path_215",
                "data-name": "Path 215",
                d: "M2.856,68.6H26.661a2.857,2.857,0,0,1,2.856,2.856V94.286H0V71.453A2.856,2.856,0,0,1,2.856,68.6",
                fill: "#a8e5e6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Path_217",
                "data-name": "Path 217",
                d: "M45.742,322.209v3.227H.043v-3.227h4.77a6.544,6.544,0,0,1,11.425,0H31.585a6.535,6.535,0,0,1,11.414,0Z",
                transform: "translate(-0.039 -227.924)",
                fill: "#334a5e"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Path_218",
                "data-name": "Path 218",
                d: "M375.35,345.8a4.56,4.56,0,1,1-4.561-4.561,4.561,4.561,0,0,1,4.561,4.561",
                transform: "translate(-333.541 -248.305)",
                fill: "#40596b"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Path_220",
                "data-name": "Path 220",
                d: "M75.459,345.8a4.561,4.561,0,1,1-4.561-4.561,4.562,4.562,0,0,1,4.561,4.561",
                transform: "translate(-60.415 -248.305)",
                fill: "#40596b"
            })
        ]
    })
});
// Refund icon for homepage banner headline
var Refund = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "41.318",
    height: "43.444",
    viewBox: "0 0 41.318 43.444",
    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
        id: "Group_333",
        "data-name": "Group 333",
        transform: "translate(-63.5 -65.419)",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                id: "Rectangle_289",
                "data-name": "Rectangle 289",
                width: "19.675",
                height: "19.675",
                rx: "0.876",
                transform: "translate(74.321 78.367)",
                fill: "#a8e5e6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Path_226",
                "data-name": "Path 226",
                d: "M79.87,72v9.838L75.935,77.9,72,81.838V72Z",
                transform: "translate(8.224 6.367)",
                fill: "#ff7058"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Path_227",
                "data-name": "Path 227",
                d: "M75.4,80.468H70.484a.984.984,0,0,1,0-1.968H75.4a.984.984,0,0,1,0,1.968Z",
                transform: "translate(5.805 12.656)",
                fill: "#334a5e"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Path_228",
                "data-name": "Path 228",
                d: "M78.354,81.968h-7.87a.984.984,0,0,1,0-1.968h7.87a.984.984,0,1,1,0,1.968Z",
                transform: "translate(5.805 14.107)",
                fill: "#334a5e"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "Group_330",
                "data-name": "Group 330",
                transform: "translate(63.5 65.419)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_229",
                        "data-name": "Path 229",
                        d: "M84.159,107.757A20.682,20.682,0,0,1,63.5,87.1a.984.984,0,1,1,1.968,0A18.691,18.691,0,1,0,86.294,68.527a.981.981,0,0,1-.864-1.088.956.956,0,0,1,1.088-.866,20.66,20.66,0,0,1-2.359,41.184Z",
                        transform: "translate(-63.5 -64.313)",
                        fill: "#334a5e"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        id: "Group_329",
                        "data-name": "Group 329",
                        transform: "translate(20.659)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "Path_230",
                            "data-name": "Path 230",
                            d: "M80.373,65.6l-3.549,3.11,3.112,3.547-2.826-.186L74,68.529l3.547-3.11Z",
                            transform: "translate(-74 -65.419)",
                            fill: "#334a5e"
                        })
                    })
                ]
            })
        ]
    })
});
// Safety guarantee icon for homepage banner headline
var Safety = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "31.908",
    height: "39.354",
    viewBox: "0 0 31.908 39.354",
    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
        id: "Group_332",
        "data-name": "Group 332",
        transform: "translate(-103.889 -20.5)",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Path_231",
                "data-name": "Path 231",
                d: "M119.716,48.154h-4.254a9.583,9.583,0,0,1-9.573-9.573V30.073a9.583,9.583,0,0,1,9.573-9.573h4.254a9.584,9.584,0,0,1,9.573,9.573v8.509A9.584,9.584,0,0,1,119.716,48.154Zm-4.254-25.527a7.453,7.453,0,0,0-7.445,7.445v8.509a7.453,7.453,0,0,0,7.445,7.445h4.254a7.455,7.455,0,0,0,7.445-7.445V30.073a7.455,7.455,0,0,0-7.445-7.445Z",
                transform: "translate(2.255 0)",
                fill: "#334a5e"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                id: "Rectangle_290",
                "data-name": "Rectangle 290",
                width: "31.908",
                height: "27.654",
                rx: "2.04",
                transform: "translate(103.889 32.2)",
                fill: "#a8e5e6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                id: "Path_232",
                "data-name": "Path 232",
                d: "M116.271,33.191a3.191,3.191,0,1,0-5.312,2.38.69.69,0,0,1,.238.647l-1.149,5.746a.669.669,0,0,0,.655.8h4.75a.669.669,0,0,0,.657-.8l-1.151-5.746a.7.7,0,0,1,.24-.647A3.179,3.179,0,0,0,116.271,33.191Z",
                transform: "translate(6.763 10.709)",
                fill: "#ff7058"
            })
        ]
    })
});

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 68 modules
var esm = __webpack_require__(5260);
;// CONCATENATED MODULE: ./components/Banner/Headline.js

// import { useTranslation } from 'next-i18next';




var HeadlineItem = function(param) {
    var mr = param.mr, title = param.title, icon = param.icon, index = param.index;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
        lineHeight: "1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                as: "span",
                role: "img",
                "aria-label": "Headline icon",
                w: "32px",
                h: "32px",
                mr: mr,
                children: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                as: "p",
                maxW: index === 1 ? 200 : index === 4 ? 100 : 150,
                children: title
            })
        ]
    });
};
function Headline() {
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
        display: {
            _: "none",
            desktop: "flex"
        },
        justify: "center",
        mb: "3rem",
        spaceX: "5rem",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadlineItem, {
                mr: "1rem",
                title: t("banner.headline1"),
                icon: Inventory,
                index: 1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadlineItem, {
                mr: "1.7rem",
                title: t("banner.headline2"),
                icon: Transport,
                index: 2
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadlineItem, {
                mr: "1.2rem",
                title: t("banner.headline3"),
                icon: Refund,
                index: 3
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadlineItem, {
                mr: "0.8rem",
                title: t("banner.headline4"),
                icon: Safety,
                index: 4
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/UI/Button/Variants/Primary.js
var Primary = __webpack_require__(6803);
// EXTERNAL MODULE: ./components/UI/Primitives/Headings.js
var Headings = __webpack_require__(7133);
// EXTERNAL MODULE: ./components/UI/Layout/Container.js
var Container = __webpack_require__(6094);
// EXTERNAL MODULE: ./components/Banner/styles.js
var styles = __webpack_require__(4804);
;// CONCATENATED MODULE: ./components/Banner/index.js












core_class/* default.use */.Z.use([
    autoplay/* default */.Z,
    pagination/* default */.Z
]);
function Banner(param) {
    var items = param.items;
    var t = (0,esm/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* BannerContainer */.UP, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                items && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* BannerSlider */.gY, {
                    loop: true,
                    pagination: (items === null || items === void 0 ? void 0 : items.length) > 1 ? {
                        clickable: true
                    } : false,
                    spaceBetween: 100,
                    autoplay: (items === null || items === void 0 ? void 0 : items.length) > 1 ? {
                        enabled: true,
                        delay: 7000
                    } : false,
                    speed: 1200,
                    children: items === null || items === void 0 ? void 0 : items.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_slide/* SwiperSlide */.o, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* BannerImage */.cW, {
                                    h: "min(50vw, 465px)",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: item.image,
                                        alt: "Banner image",
                                        layout: "fill",
                                        priority: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* FlexBox */.h, {
                                    justify: {
                                        _: "center",
                                        desktop: "start"
                                    },
                                    mb: {
                                        desktop: "5rem"
                                    },
                                    mt: {
                                        _: "4rem",
                                        desktop: "0rem"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* BannerBox */.C2, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings/* SectionTitle */.NZ, {
                                                as: "h1",
                                                children: item.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: item.description
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Primary/* default */.Z, {
                                                mt: "2rem",
                                                padding: "0.5rem 2rem",
                                                onClick: function() {
                                                    return router.push(item.path);
                                                },
                                                children: t("banner.button")
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, item.image);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline, {})
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper.js + 8 modules
var swiper = __webpack_require__(9447);
// EXTERNAL MODULE: ./components/UI/ProductCard/index.js
var ProductCard = __webpack_require__(681);
// EXTERNAL MODULE: ./components/UI/Primitives/CarouselArrow.js
var CarouselArrow = __webpack_require__(7184);
// EXTERNAL MODULE: ./components/UI/Icons/index.js
var Icons = __webpack_require__(9430);
// EXTERNAL MODULE: ./components/UI/Skeletons/SkeletonProductCard.js
var SkeletonProductCard = __webpack_require__(3327);
// EXTERNAL MODULE: ./hooks/products/useCatalogue.js
var useCatalogue = __webpack_require__(4457);
;// CONCATENATED MODULE: ./components/Home/Bestsellers/BestsellerSlider.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n\n  @media (max-width: desktop) {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  position: relative;\n  bottom: 1rem;\n  right: ",
        ";\n  left: ",
        ";\n\n  @media (min-width: desktop) and (max-width: lg_desktop) {\n    right: ",
        ";\n    left: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  padding-bottom: 3rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var SliderContainer = styled_components_esm/* default.div */.ZPm.div(_templateObject());
var Arrow = styled_components_esm/* default.div */.ZPm.div(_templateObject1(), function(param) {
    var prev = param.prev;
    return prev && "1.5rem";
}, function(param) {
    var next = param.next;
    return next && "0.75rem";
}, function(param) {
    var prev = param.prev;
    return prev && "0.75rem";
}, function(param) {
    var next = param.next;
    return next && "0.2rem";
});
var StyledSwiper = (0,styled_components_esm/* default */.ZPm)(swiper/* Swiper */.t)(_templateObject2());
function PopularProductSlider(param) {
    var bestsellers = param.bestsellers;
    var swiperRef = (0,react.useRef)(null);
    var numArray = _toConsumableArray(Array(4));
    var loading = (0,useCatalogue/* default */.Z)().loading;
    var router = (0,next_router.useRouter)();
    var lang = router.locale ? router.locale : "et";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SliderContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {
                prev: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselArrow/* default */.Z, {
                    onClick: function() {
                        return swiperRef.current.swiper.slidePrev();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* SliderArrowLeft */.wT, {
                        strokeWidth: 6
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwiper, {
                    ref: swiperRef,
                    spaceBetween: 14,
                    breakpoints: {
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 1
                        },
                        1280: {
                            slidesPerView: 4
                        }
                    },
                    loop: true,
                    children: numArray === null || numArray === void 0 ? void 0 : numArray.map(function(_, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonProductCard/* default */.Z, {})
                        }, i);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwiper, {
                    ref: swiperRef,
                    spaceBetween: 14,
                    breakpoints: {
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 1
                        },
                        1280: {
                            slidesPerView: 4
                        }
                    },
                    loop: true,
                    children: bestsellers === null || bestsellers === void 0 ? void 0 : bestsellers.map(function(product, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
                                hideRating: true,
                                badges: {
                                    discount: {
                                        text: lang === "en" ? "Favourite" : "Lemmik"
                                    }
                                },
                                product: product,
                                w: {
                                    lg_desktop: 260
                                },
                                priority: i <= 4 ? true : false,
                                imageSize: {
                                    width: 1000,
                                    height: 1040
                                }
                            })
                        }, product.name);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {
                next: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselArrow/* default */.Z, {
                    onClick: function() {
                        return swiperRef.current.swiper.slideNext();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* SliderArrowRight */.C$, {
                        strokeWidth: 6
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@xstyled/core/dist/core.esm.js
var core_esm = __webpack_require__(1278);
// EXTERNAL MODULE: ./components/UI/Skeletons/SkeletonSmallCard.js
var SkeletonSmallCard = __webpack_require__(9081);
;// CONCATENATED MODULE: ./components/Home/Bestsellers/BestsellerSwiper.js
function BestsellerSwiper_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function BestsellerSwiper_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return BestsellerSwiper_arrayLikeToArray(arr);
}
function BestsellerSwiper_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function BestsellerSwiper_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function BestsellerSwiper_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function BestsellerSwiper_toConsumableArray(arr) {
    return BestsellerSwiper_arrayWithoutHoles(arr) || BestsellerSwiper_iterableToArray(arr) || BestsellerSwiper_unsupportedIterableToArray(arr) || BestsellerSwiper_nonIterableSpread();
}
function BestsellerSwiper_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return BestsellerSwiper_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return BestsellerSwiper_arrayLikeToArray(o, minLen);
}
function BestsellerSwiper_templateObject() {
    var data = BestsellerSwiper_taggedTemplateLiteral([
        "\n  .swiper-slide div {\n    margin: ",
        ";\n  }\n"
    ]);
    BestsellerSwiper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BestsellerSwiper_templateObject1() {
    var data = BestsellerSwiper_taggedTemplateLiteral([
        "\n  padding-bottom: 3rem;\n\n  .swiper-pagination {\n    margin-left: -1rem;\n  }\n\n  .swiper-pagination-bullet-active {\n    background-color: teal-300;\n  }\n\n  @media (min-width: desktop) {\n    display: none;\n  }\n"
    ]);
    BestsellerSwiper_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








core_class/* default.use */.Z.use([
    pagination/* default */.Z
]);
var BestsellerSwiper_Container = styled_components_esm/* default.div */.ZPm.div(BestsellerSwiper_templateObject(), function(param) {
    var viewportWidth = param.viewportWidth;
    return viewportWidth <= 375 ? "0 auto" : "unset";
});
var BestsellerSwiper_StyledSwiper = (0,styled_components_esm/* default */.ZPm)(swiper/* Swiper */.t)(BestsellerSwiper_templateObject1());
function PopularProductSwiper(param) {
    var bestsellers = param.bestsellers;
    var viewportWidth = (0,core_esm/* useViewportWidth */.jK)();
    var loading = (0,useCatalogue/* default */.Z)().loading;
    var numArray = BestsellerSwiper_toConsumableArray(Array(9));
    var router = (0,next_router.useRouter)();
    var lang = router.locale ? router.locale : "et";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BestsellerSwiper_Container, {
        viewportWidth: viewportWidth,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BestsellerSwiper_StyledSwiper, {
            loop: true,
            spaceBetween: 100,
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 0
                },
                350: {
                    slidesPerView: 2,
                    spaceBetween: 80
                },
                450: {
                    slidesPerView: 2,
                    spaceBetween: 0
                },
                560: {
                    slidesPerView: 3,
                    spaceBetween: 80
                },
                650: {
                    slidesPerView: 3,
                    spaceBetween: 0
                },
                760: {
                    slidesPerView: 4,
                    spaceBetween: 80
                },
                850: {
                    slidesPerView: 4,
                    spaceBetween: 0
                },
                992: {
                    slidesPerView: 5,
                    spaceBetween: 80
                }
            },
            pagination: {
                dynamicBullets: true,
                dynamicMainBullets: 3
            },
            children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: numArray.map(function(_, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonSmallCard/* default */.Z, {})
                    }, i);
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: bestsellers === null || bestsellers === void 0 ? void 0 : bestsellers.map(function(product, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, {
                            hideRating: true,
                            badges: {
                                discount: {
                                    text: lang === "en" ? "Favourite" : "Lemmik"
                                }
                            },
                            product: product,
                            w: 200,
                            priority: i <= 2 ? true : false,
                            imageSize: {
                                width: 1000,
                                height: 1040
                            }
                        })
                    }, i);
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./components/UI/Loader/index.js
var Loader = __webpack_require__(1395);
;// CONCATENATED MODULE: ./components/Home/Bestsellers/index.js
function Bestsellers_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Bestsellers_templateObject() {
    var data = Bestsellers_taggedTemplateLiteral([
        "\n  width: 100vw;\n  padding: 3rem 1rem;\n  background-color: white;\n\n  a {\n    display: block;\n    text-align: center;\n    color: black;\n    font-weight: 700;\n    text-decoration: underline;\n\n    &:hover {\n      cursor: pointer;\n      color: teal-400;\n    }\n  }\n\n  @media (min-width: desktop) {\n    padding: 3rem 2rem;\n  }\n"
    ]);
    Bestsellers_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var BestsellersWrapper = styled_components_esm/* default.section */.ZPm.section(Bestsellers_templateObject());
function Bestsellers(param) {
    var bestsellers = param.bestsellers;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BestsellersWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings/* SectionTitle */.NZ, {
                    display: {
                        _: "block",
                        desktop: "none"
                    },
                    mb: "1rem",
                    children: t("home.popular_products")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                    display: {
                        _: "none",
                        desktop: "flex"
                    },
                    align: "center",
                    justify: "space-between",
                    mb: "3rem",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings/* SectionTitle */.NZ, {
                            children: t("home.popular_products")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/kataloog/lapsevankrid-ja-karud",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                children: [
                                    t("home.all_products"),
                                    " >"
                                ]
                            })
                        })
                    ]
                }),
                bestsellers ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularProductSwiper, {
                            bestsellers: bestsellers
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularProductSlider, {
                            bestsellers: bestsellers
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                    display: {
                        _: "block",
                        desktop: "none"
                    },
                    mt: "1rem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/kataloog/vankrid",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            children: [
                                t("home.all_products"),
                                " >"
                            ]
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/UI/Image/index.js
var Image = __webpack_require__(9696);
;// CONCATENATED MODULE: ./components/Home/Blog/Entry.js
function Entry_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Entry_templateObject() {
    var data = Entry_taggedTemplateLiteral([
        "\n  a:first-child {\n    display: block;\n    position: relative;\n    width: 100%;\n    height: 300px;\n\n    img {\n      border-radius: 12px;\n\n      &:hover {\n        filter: brightness(0.9) contrast(105%);\n        transition: filter 0.2s;\n      }\n    }\n  }\n\n  p {\n    padding-bottom: 0.5rem;\n    color: gray-100;\n    letter-spacing: 0.7;\n    font-size: 14px;\n    text-transform: uppercase;\n  }\n"
    ]);
    Entry_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var EntryContainer = styled_components_esm/* default.div */.ZPm.div(Entry_templateObject());
/**
 * BlogEntry
 *
 * A card-like component rendering a single blog entry on the homepage
 *
 * @prop {object} post - blog post object { categories, title, image, path }
 */ function BlogEntry(param) {
    var post = param.post;
    var ref;
    var theme = (0,styled_components_esm/* useTheme */.FgM)();
    var category = (ref = post === null || post === void 0 ? void 0 : post.categories[0]) === null || ref === void 0 ? void 0 : ref.title;
    var postPath = "/blogi/".concat(post.identifier);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EntryContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: postPath,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: post.featured_image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: post.featured_image,
                        alt: post.title,
                        layout: "fill"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_esm/* Box */.xuv, {
                p: "2rem 0.25rem 2.875rem",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: category
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: postPath,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings/* SectionTitle */.NZ, {
                                maxW: 600,
                                fontSize: theme.fontSizes.medium,
                                lineHeight: "1.5",
                                hoverOpacity: "0.7",
                                children: post.title
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Home/Blog/index.js
function Blog_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Blog_templateObject() {
    var data = Blog_taggedTemplateLiteral([
        "\n  @media (min-width: desktop) {\n    display: grid;\n    grid-template-columns: ",
        ";\n    grid-column-gap: 1rem;\n  }\n\n  margin-bottom: 1rem;\n"
    ]);
    Blog_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Blog_templateObject1() {
    var data = Blog_taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 2rem 1rem 3rem;\n  background-color: white;\n\n  ",
        ":nth-of-type(1) {\n    margin-top: 3rem;\n\n    @media (max-width: desktop) {\n      margin-top: 2.625rem;\n    }\n  }\n\n  @media (min-width: desktop) {\n    padding: 4rem 2rem 3rem;\n\n    ",
        ":nth-of-type(2) {\n      margin-bottom: 2rem;\n    }\n  }\n"
    ]);
    Blog_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var BlogGrid = styled_components_esm/* default.div */.ZPm.div(Blog_templateObject(), function(param) {
    var cols = param.cols;
    return cols;
});
var BlogContainer = styled_components_esm/* default.section */.ZPm.section(Blog_templateObject1(), BlogGrid, BlogGrid);
function Blog(param) {
    var blogPosts = param.blogPosts;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlogContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/blogi",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings/* SectionTitle */.NZ, {
                            hoverOpacity: "0.7",
                            children: "Blogi"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogGrid, {
                    cols: "1.5fr 1fr",
                    children: blogPosts === null || blogPosts === void 0 ? void 0 : blogPosts.slice(0, 2).map(function(post) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogEntry, {
                            post: post
                        }, post.identifier);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogGrid, {
                    cols: "1fr 1.5fr",
                    children: blogPosts === null || blogPosts === void 0 ? void 0 : blogPosts.slice(2, 4).map(function(post) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogEntry, {
                            post: post
                        }, post.identifier);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/Home/Brands/index.js
function Brands_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Brands_templateObject() {
    var data = Brands_taggedTemplateLiteral([
        "\n  padding: 0 3.5rem 6rem;\n  background-color: white;\n\n  ul {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-row-gap: 1rem;\n\n    @media (min-width: desktop) {\n      padding: 4rem 4.5rem 6rem;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n\n    + a {\n      display: block;\n      text-align: center;\n      color: black;\n      font-weight: 700;\n      text-decoration: none;\n\n      &:hover {\n        cursor: pointer;\n        color: teal-400;\n      }\n\n      @media (max-width: desktop) {\n        margin-top: 2rem;\n      }\n    }\n  }\n"
    ]);
    Brands_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var BrandContainer = styled_components_esm/* default.section */.ZPm.section(Brands_templateObject());
function FeaturedBrands(param) {
    var brands = param.brands;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BrandContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: brands === null || brands === void 0 ? void 0 : brands.map(function(brand) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/brands/".concat(brand.url_key, "?id=").concat(brand.option_id),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: brand.image,
                                        alt: brand.value,
                                        width: 100,
                                        height: 100,
                                        objectFit: "contain"
                                    })
                                })
                            })
                        }, brand.option_id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/brands",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        children: [
                            t("home.see_all_brands"),
                            " >"
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/SEO.js
var SEO = __webpack_require__(9831);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./pages/index.js










var Categories = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 305).then(__webpack_require__.bind(__webpack_require__, 305));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(305)
            ];
        }
    }
});
var __N_SSP = true;
function Home(param) {
    var bannerItems = param.bannerItems, categories = param.categories, bestsellers = param.bestsellers, blogPosts = param.blogPosts, brands = param.brands, meta = param.meta;
    // Restore scroll position when returning from a page
    // useScrollRestoration({ data: bannerItems });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        categories: categories,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                seo: {
                    title: meta.title ? meta.title : "Baltbaby",
                    description: meta.description ? meta.description : "Baltbaby on baltikumi suurim beebitoodete e-kaubamaja. Baltbaby tootevalikust leiad suures koguses beebiriideid, vankreid ja muud beebi- ja lastekaupa."
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "application/ld+json",
                id: "baltbaby_sitelinks_structured_data",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "WebSite",
                        url: "https://baltbaby.com",
                        potentialAction: {
                            "@type": "SearchAction",
                            target: "https://baltbaby.com/otsing/{search_term_string}",
                            "query-input": "required name=search_term_string"
                        }
                    })
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, {
                items: bannerItems
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bestsellers, {
                bestsellers: bestsellers
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories, {
                categories: categories
            }),
            blogPosts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog, {
                blogPosts: blogPosts
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedBrands, {
                brands: brands
            })
        ]
    });
};


/***/ }),

/***/ 4244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getCategoryId; }
/* harmony export */ });
/* harmony import */ var global_data__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6863);

function getCategoryId(slug) {
    var category1 = global_data__WEBPACK_IMPORTED_MODULE_0__/* .categories.find */ .bd.find(function(category) {
        return category.url_key === slug;
    });
    var id = category1 === null || category1 === void 0 ? void 0 : category1.id.toString();
    return id;
};


/***/ }),

/***/ 8609:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"skeletonproductimage":"Skeleton_skeletonproductimage__iedNz","skeletontitle":"Skeleton_skeletontitle__mmij2","skeletontext":"Skeleton_skeletontext__BMljH","mobileskeletonimage":"Skeleton_mobileskeletonimage__LE2pX","mobileskeletontitle":"Skeleton_mobileskeletontitle__uG6xV","mobileskeletontext":"Skeleton_mobileskeletontext__DK8qh"};

/***/ }),

/***/ 7649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var ssr_window__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6156);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8262);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint no-underscore-dangle: "off" */


var Autoplay = {
  run: function run() {
    var swiper = this;
    var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    var delay = swiper.params.autoplay.delay;

    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }

    clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.timeout = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .nextTick */ .Y3)(function () {
      var autoplayResult;

      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isBeginning) {
          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.isEnd) {
        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else {
        swiper.autoplay.stop();
      }

      if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();else if (autoplayResult === false) {
        swiper.autoplay.run();
      }
    }, delay);
  },
  start: function start() {
    var swiper = this;
    if (typeof swiper.autoplay.timeout !== 'undefined') return false;
    if (swiper.autoplay.running) return false;
    swiper.autoplay.running = true;
    swiper.emit('autoplayStart');
    swiper.autoplay.run();
    return true;
  },
  stop: function stop() {
    var swiper = this;
    if (!swiper.autoplay.running) return false;
    if (typeof swiper.autoplay.timeout === 'undefined') return false;

    if (swiper.autoplay.timeout) {
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = undefined;
    }

    swiper.autoplay.running = false;
    swiper.emit('autoplayStop');
    return true;
  },
  pause: function pause(speed) {
    var swiper = this;
    if (!swiper.autoplay.running) return;
    if (swiper.autoplay.paused) return;
    if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.paused = true;

    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      swiper.autoplay.run();
    } else {
      ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
        swiper.$wrapperEl[0].addEventListener(event, swiper.autoplay.onTransitionEnd);
      });
    }
  },
  onVisibilityChange: function onVisibilityChange() {
    var swiper = this;
    var document = (0,ssr_window__WEBPACK_IMPORTED_MODULE_0__/* .getDocument */ .Me)();

    if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
      swiper.autoplay.pause();
    }

    if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
      swiper.autoplay.run();
      swiper.autoplay.paused = false;
    }
  },
  onTransitionEnd: function onTransitionEnd(e) {
    var swiper = this;
    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
    if (e.target !== swiper.$wrapperEl[0]) return;
    ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
      swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
    });
    swiper.autoplay.paused = false;

    if (!swiper.autoplay.running) {
      swiper.autoplay.stop();
    } else {
      swiper.autoplay.run();
    }
  },
  onMouseEnter: function onMouseEnter() {
    var swiper = this;

    if (swiper.params.autoplay.disableOnInteraction) {
      swiper.autoplay.stop();
    } else {
      swiper.autoplay.pause();
    }

    ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
      swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
    });
  },
  onMouseLeave: function onMouseLeave() {
    var swiper = this;

    if (swiper.params.autoplay.disableOnInteraction) {
      return;
    }

    swiper.autoplay.paused = false;
    swiper.autoplay.run();
  },
  attachMouseEvents: function attachMouseEvents() {
    var swiper = this;

    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.$el.on('mouseenter', swiper.autoplay.onMouseEnter);
      swiper.$el.on('mouseleave', swiper.autoplay.onMouseLeave);
    }
  },
  detachMouseEvents: function detachMouseEvents() {
    var swiper = this;
    swiper.$el.off('mouseenter', swiper.autoplay.onMouseEnter);
    swiper.$el.off('mouseleave', swiper.autoplay.onMouseLeave);
  }
};
/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'autoplay',
  params: {
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  },
  create: function create() {
    var swiper = this;
    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .bindModuleMethods */ .cR)(swiper, {
      autoplay: _extends({}, Autoplay, {
        running: false,
        paused: false
      })
    });
  },
  on: {
    init: function init(swiper) {
      if (swiper.params.autoplay.enabled) {
        swiper.autoplay.start();
        var document = (0,ssr_window__WEBPACK_IMPORTED_MODULE_0__/* .getDocument */ .Me)();
        document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
        swiper.autoplay.attachMouseEvents();
      }
    },
    beforeTransitionStart: function beforeTransitionStart(swiper, speed, internal) {
      if (swiper.autoplay.running) {
        if (internal || !swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.pause(speed);
        } else {
          swiper.autoplay.stop();
        }
      }
    },
    sliderFirstMove: function sliderFirstMove(swiper) {
      if (swiper.autoplay.running) {
        if (swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.stop();
        } else {
          swiper.autoplay.pause();
        }
      }
    },
    touchEnd: function touchEnd(swiper) {
      if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
        swiper.autoplay.run();
      }
    },
    destroy: function destroy(swiper) {
      swiper.autoplay.detachMouseEvents();

      if (swiper.autoplay.running) {
        swiper.autoplay.stop();
      }

      var document = (0,ssr_window__WEBPACK_IMPORTED_MODULE_0__/* .getDocument */ .Me)();
      document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
    }
  }
});

/***/ }),

/***/ 2997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8557);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8262);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Pagination = {
  update: function update() {
    // Render || Update Pagination bullets/items
    var swiper = this;
    var rtl = swiper.rtl;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el; // Current/Total

    var current;
    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      var bullets = swiper.pagination.bullets;
      var firstIndex;
      var lastIndex;
      var midIndex;

      if (params.dynamicBullets) {
        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;

          if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (swiper.pagination.dynamicBulletIndex < 0) {
            swiper.pagination.dynamicBulletIndex = 0;
          }
        }

        firstIndex = current - swiper.pagination.dynamicBulletIndex;
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");

      if ($el.length > 1) {
        bullets.each(function (bullet) {
          var $bullet = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(bullet);
          var bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(params.bulletActiveClass + "-main");
            }

            if (bulletIndex === firstIndex) {
              $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            }

            if (bulletIndex === lastIndex) {
              $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          }
        });
      } else {
        var $bullet = bullets.eq(current);
        var bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          var $firstDisplayedBullet = bullets.eq(firstIndex);
          var $lastDisplayedBullet = bullets.eq(lastIndex);

          for (var i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(params.bulletActiveClass + "-main");
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
              for (var _i = params.dynamicMainBullets; _i >= 0; _i -= 1) {
                bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
            } else {
              $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
              $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          } else {
            $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
          }
        }
      }

      if (params.dynamicBullets) {
        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
        var offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
      }
    }

    if (params.type === 'fraction') {
      $el.find((0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find((0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      var progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      var scale = (current + 1) / total;
      var scaleX = 1;
      var scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find((0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      swiper.emit('paginationRender', $el[0]);
    } else {
      swiper.emit('paginationUpdate', $el[0]);
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  },
  render: function render() {
    // Render Container
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el;
    var paginationHTML = '';

    if (params.type === 'bullets') {
      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.freeMode && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }

      for (var i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find((0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      swiper.emit('paginationRender', swiper.pagination.$el[0]);
    }
  },
  init: function init() {
    var swiper = this;
    swiper.params.pagination = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .createElementIfNotDefined */ .Up)(swiper.$el, swiper.params.pagination, swiper.params.createElements, {
      el: 'swiper-pagination'
    });
    var params = swiper.params.pagination;
    if (!params.el) return;
    var $el = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el);
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass("" + params.modifierClass + params.type + "-dynamic");
      swiper.pagination.dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(params.bulletClass), function onClick(e) {
        e.preventDefault();
        var index = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .extend */ .l7)(swiper.pagination, {
      $el: $el,
      el: $el[0]
    });

    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .classesToSelector */ .Wc)(params.bulletClass));
    }
  }
};
/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'pagination',
  params: {
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: function formatFractionCurrent(number) {
        return number;
      },
      formatFractionTotal: function formatFractionTotal(number) {
        return number;
      },
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      modifierClass: 'swiper-pagination-',
      // NEW
      currentClass: 'swiper-pagination-current',
      totalClass: 'swiper-pagination-total',
      hiddenClass: 'swiper-pagination-hidden',
      progressbarFillClass: 'swiper-pagination-progressbar-fill',
      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
      clickableClass: 'swiper-pagination-clickable',
      // NEW
      lockClass: 'swiper-pagination-lock'
    }
  },
  create: function create() {
    var swiper = this;
    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .bindModuleMethods */ .cR)(swiper, {
      pagination: _extends({
        dynamicBulletIndex: 0
      }, Pagination)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.pagination.init();
      swiper.pagination.render();
      swiper.pagination.update();
    },
    activeIndexChange: function activeIndexChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.update();
      } else if (typeof swiper.snapIndex === 'undefined') {
        swiper.pagination.update();
      }
    },
    snapIndexChange: function snapIndexChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.update();
      }
    },
    slidesLengthChange: function slidesLengthChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    snapGridLengthChange: function snapGridLengthChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    destroy: function destroy(swiper) {
      swiper.pagination.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var $el = swiper.pagination.$el;

      if ($el) {
        $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
      }
    },
    click: function click(swiper, e) {
      var targetEl = e.target;

      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !(0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
        if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
        var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);

        if (isHidden === true) {
          swiper.emit('paginationShow');
        } else {
          swiper.emit('paginationHide');
        }

        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
      }
    }
  }
});

/***/ }),

/***/ 4002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ SwiperSlide; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1077);
/* harmony import */ var _use_isomorphic_layout_effect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7254);
var _excluded = ["tag", "children", "className", "swiper", "zoom", "virtualIndex"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var SwiperSlide = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_temp, externalRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      swiper = _ref.swiper,
      zoom = _ref.zoom,
      virtualIndex = _ref.virtualIndex,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var slideElRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)('swiper-slide'),
      slideClasses = _useState[0],
      setSlideClasses = _useState[1];

  function updateClasses(swiper, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }

  (0,_use_isomorphic_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useIsomorphicLayoutEffect */ .L)(function () {
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }

    if (!slideElRef.current || !swiper) {
      return;
    }

    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }

      return;
    }

    swiper.on('_slideClass', updateClasses); // eslint-disable-next-line

    return function () {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  (0,_use_isomorphic_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useIsomorphicLayoutEffect */ .L)(function () {
    if (swiper && slideElRef.current) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  var slideData;

  if (typeof children === 'function') {
    slideData = {
      isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
      isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
      isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
      isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
      isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
    };
  }

  var renderChildren = function renderChildren() {
    return typeof children === 'function' ? children(slideData) : children;
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tag, _extends({
    ref: slideElRef,
    className: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .uniqueClasses */ .kI)("" + slideClasses + (className ? " " + className : '')),
    "data-swiper-slide-index": virtualIndex
  }, rest), zoom ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren()) : renderChildren());
});
SwiperSlide.displayName = 'SwiperSlide';


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4337,1664,7536,9669,5675,3305,9447,2483,5275,1979,9085,8435,9774,2888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);